module.exports = {
          srcSet: __webpack_public_path__ + "f35fd2ac6745bb74a2f12ea19607a949-76.png"+" 76w",
          images:[ {path: __webpack_public_path__ + "f35fd2ac6745bb74a2f12ea19607a949-76.png",width: 76,height: 78}],
          src: __webpack_public_path__ + "f35fd2ac6745bb74a2f12ea19607a949-76.png",
          toString:function(){return __webpack_public_path__ + "f35fd2ac6745bb74a2f12ea19607a949-76.png"},
          
          width: 76,
          height: 78
        }